function runWhenInit() {
  window.liquidAjaxCart.conf('updateOnWindowFocus', false);
}

if (window.liquidAjaxCart?.init) {
  // if Liquid Ajax Cart is already initialized
  runWhenInit();
} else {
  // wait for Liquid Ajax Cart to be initialized
  document.addEventListener("liquid-ajax-cart:init", runWhenInit);
}

document.addEventListener('DOMContentLoaded', () => {
  bindCartOpenButtons();
  bindCartCloseButton();
});

document.addEventListener('liquid-ajax-cart:request-end', event => {
  const { requestState } = event.detail;

  if (requestState.requestType === 'add' && requestState.responseData?.ok) {
    //openCart(event);
  }

  bindCartCloseButton();
  changeNotification();
});

/**
 * Subscription toggle — uses liquidAjaxCart.change() to swap a cart line
 * between one-time and subscription selling plan.
 *
 * Uses event delegation on the document so it works after every
 * liquid-ajax-cart re-render without needing to re-bind listeners.
 */
document.addEventListener('change', event => {
  const toggle = event.target.closest('.cart__sub-toggle-input');
  const select = event.target.closest('.cart__sub-frequency-select');

  if (!toggle && !select) return;

  const widget = (toggle || select).closest('.cart__drawer-item-subscription');
  if (!widget) return;

  const line      = parseInt(widget.getAttribute('data-line'), 10);
  const toggleEl  = widget.querySelector('.cart__sub-toggle-input');
  const selectEl  = widget.querySelector('.cart__sub-frequency-select');
  const freqWrap  = widget.querySelector('.cart__sub-frequency-wrap');

  if (!toggleEl || !selectEl) return;

  // Show/hide the frequency dropdown when the toggle changes
  if (toggle && freqWrap) {
    freqWrap.classList.toggle('cart__sub-frequency-wrap--hidden', !toggleEl.checked);
  }

  // Determine which selling_plan to send
  const sellingPlanId = toggleEl.checked ? selectEl.value : '';

  // Get the current quantity from the cart to preserve it during the change
  const cartItem = window.liquidAjaxCart?.cart?.items?.[line - 1];
  const currentQuantity = cartItem ? cartItem.quantity : 1;

  liquidAjaxCart.change({
    line,
    quantity: currentQuantity,
    selling_plan: sellingPlanId
  });
});

// Open / close the custom frequency dropdown
document.addEventListener('click', event => {
  const trigger = event.target.closest('.cart__sub-frequency-trigger');
  const dropdown = trigger?.closest('.cart__sub-frequency-dropdown');

  // Close any other open dropdowns
  document.querySelectorAll('.cart__sub-frequency-dropdown--open').forEach(d => {
    if (d !== dropdown) {
      d.classList.remove('cart__sub-frequency-dropdown--open');
      d.querySelector('.cart__sub-frequency-trigger')?.setAttribute('aria-expanded', 'false');
    }
  });

  if (dropdown) {
    const isOpen = dropdown.classList.toggle('cart__sub-frequency-dropdown--open');
    trigger.setAttribute('aria-expanded', String(isOpen));
  }
});

// Select a frequency option from the custom dropdown
document.addEventListener('click', event => {
  const item = event.target.closest('.cart__sub-frequency-item');
  if (!item) return;

  const dropdown = item.closest('.cart__sub-frequency-dropdown');
  const widget   = item.closest('.cart__drawer-item-subscription');
  const selectEl = widget?.querySelector('.cart__sub-frequency-select');

  // Update active state and displayed text
  dropdown.querySelectorAll('.cart__sub-frequency-item').forEach(i => i.classList.remove('active'));
  item.classList.add('active');
  dropdown.querySelector('.cart__sub-frequency-text').textContent = item.textContent.trim();

  // Close the dropdown
  dropdown.classList.remove('cart__sub-frequency-dropdown--open');
  dropdown.querySelector('.cart__sub-frequency-trigger').setAttribute('aria-expanded', 'false');

  // Sync hidden select and trigger existing liquidAjaxCart logic
  if (selectEl) {
    selectEl.value = item.dataset.planId;
    selectEl.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

// Close dropdown when clicking outside
document.addEventListener('click', event => {
  if (event.target.closest('.cart__sub-frequency-dropdown')) return;

  document.querySelectorAll('.cart__sub-frequency-dropdown--open').forEach(d => {
    d.classList.remove('cart__sub-frequency-dropdown--open');
    d.querySelector('.cart__sub-frequency-trigger')?.setAttribute('aria-expanded', 'false');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (new URLSearchParams(location.search).has('cart-added')) {
    document.body.classList.add('js-show-ajax-cart');
  }
});

/**
 * Updates the cart notification badge with the current item count.
 * Hides the badge if the cart is empty.
 *
 * @returns {void}
 */
function changeNotification() {
  const countCart = window.liquidAjaxCart.cart.item_count;
  const updateNotification = document.querySelector('[data-count-cart]');
  const bagIcon = document.querySelector('#bag-icon');

  if(!updateNotification) return;
  if (countCart == 0) {
    updateNotification.classList.add('hidden');
    if (bagIcon) {
      bagIcon.classList.remove('items-added');
    }
    return
  }
  updateNotification.classList.remove('hidden');
  updateNotification.textContent = countCart;
  if (bagIcon) {
    bagIcon.classList.add('items-added');
  }
}

/**
 * Opens the AJAX cart by adding the corresponding body class.
 * Prevents the default event action if triggered by a clickable element.
 *
 * @param {Event} [event] - The event that triggered the cart opening.
 * @returns {void}
 */
function openCart(event) {
  if (event?.preventDefault) event.preventDefault();
  document.body.classList.add('js-show-ajax-cart');

  if (window.liquidAjaxCart?.cart) {
    manageTierRewards(window.liquidAjaxCart.cart);
  }

}

function restart() {
  document.body.classList.remove('js-show-ajax-cart');
}

function bindCartCloseButton() {
  const buttonsClose = document.querySelectorAll('.ajax-close-cart');
  buttonsClose.forEach(button => {
    button.addEventListener('click', restart);
  });
}

function bindCartOpenButtons() {
  const buttonsOpen = document.querySelectorAll('.ajax-open-cart');
  buttonsOpen.forEach(button => {
    button.addEventListener('click', openCart);
  });
}

/**
 * It's for Subscription Toggle on Sidecart Test
*/
/* window.addEventListener('featureManager::ready', () => {
  FeatureManager.onRunChange(
    { key: "subscription-toggle-sidecart", variations: ["control", "variant"] },
    (variant) => {
      if (variant === "variant") {
        document.body.setAttribute("data-test-subscription-toggle-sidecart", "true");
      } else {
        document.body.removeAttribute("data-test-subscription-toggle-sidecart");
      }
    }
  );
}); */